import { render, staticRenderFns } from "./CostBearerEducationInvoicePreview.vue?vue&type=template&id=abe250f8&scoped=true&"
import script from "./CostBearerEducationInvoicePreview.vue?vue&type=script&lang=ts&"
export * from "./CostBearerEducationInvoicePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe250f8",
  null
  
)

export default component.exports